import React, { useEffect, useRef, useState } from 'react';
import { FaPlay, FaPause, } from 'react-icons/fa';
import { toogleReload } from '../../../Utils/reloadSlice';
import { useDispatch } from 'react-redux';
import { toogleLibraryEdit } from '../../../Utils/libraryEditSlice';

const LibraryCard = ({ data, setEditLibrary }) => {
    const audioRef = useRef(null);
    const dispatch = useDispatch();
    const [isPlaying, setIsPlaying] = useState(false);
    const [currentTime, setCurrentTime] = useState(0);
    const [duration, setDuration] = useState(0);
    const [loading, setLoading] = useState(false);
    const [visible, setVisible] = useState(false);

    const handlePlayPause = () => {
        if (isPlaying) {
        audioRef.current.pause();
        } else {
        audioRef.current.play();
        }
        setIsPlaying(!isPlaying);
    };

    const handleTimeUpdate = () => {
        setCurrentTime(audioRef.current.currentTime);
    };

    const handleLoadedMetadata = () => {
        setDuration(audioRef.current.duration);
    };

    const handleSeek = (event) => {
        const seekTime = (event.target.value / 100) * duration;
        audioRef.current.currentTime = seekTime;
        setCurrentTime(seekTime);
    };

    useEffect(() => {
        const audio = audioRef.current;
        audio.addEventListener('timeupdate', handleTimeUpdate);
        audio.addEventListener('loadedmetadata', handleLoadedMetadata);

        return () => {
        audio.removeEventListener('timeupdate', handleTimeUpdate);
        audio.removeEventListener('loadedmetadata', handleLoadedMetadata);
        };
    }, []);

    const handleChange = async (id, value) => {
        setLoading(true);
        await fetch(`https://app-api.mokx.org/api/v1/slok/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify({
                "lockSlok": value,
            }),
        });
        setLoading(false);
        dispatch(toogleReload())
    }

    const handleEdit = async (id) => {
        setLoading(true);
        const getData = await fetch(`https://app-api.mokx.org/api/v1/slok/${id}`);
        const json = await getData.json();
        setEditLibrary(json.data.slok);
        setTimeout(() => {
          dispatch(toogleLibraryEdit());
        }, 500)
        setLoading(false);
    }

    const handleDelete = (id) => {
        setLoading(true);
        const deleteUrl = `https://app-api.mokx.org/api/v1/slok/${id}`;
        fetch(deleteUrl, {
          method: 'DELETE',
        })
        .then((response) => {
          if (response.ok) {
            alert('Slok deleted successfully');
            dispatch(toogleReload());
          } else {
            alert('Failed to delete resource');
          }
        })
        .catch((error) => {
          // Handle network errors
          console.error('Network error:', error);
        });
        setLoading(false);
    }

    return (
        <div key={data._id} className="relative lg:w-[48%] md:w-[48%] w-[100%] py-7 pr-9 pl-10 mb-4 rounded-xl bg-[#FFF] drop-shadow-3Xl p-4" onMouseLeave={() => setVisible(false)}>
            <div className='flex items-center gap-5 mb-4'>
                {data.slokImage && <button onMouseEnter={() => setVisible(true)}>
                    <img className='w-[30px] h-[30px]' src={data.slokImage} alt="slokImage" />
                </button>}
                <div>
                    <h1 className='text-[#000] text-2xl font-figtree font-semibold'>{data.heading}</h1>
                    <div className='font-thin text-xs mb-4'>{data.subHeading}</div>
                </div>
            </div>
            <div className="audio-player">
                <audio
                    ref={audioRef}
                    className="hidden"
                    onTimeUpdate={handleTimeUpdate}
                    onLoadedMetadata={handleLoadedMetadata}
                >
                    <source src={data.slokLink} type="video/mp4" />
                    Your browser does not support the audio element.
                </audio>
                <div className="flex items-center justify-between w-full gap-3">
                    <button onClick={handlePlayPause} className="p-2 rounded-full bg-blue-500 text-white">
                        {isPlaying ? <FaPause /> : <FaPlay />}
                    </button>
                    <input
                        type="range"
                        value={(currentTime / duration) * 100 || 0}
                        onChange={handleSeek}
                        className="w-[60%]"
                    />
                    <span className="text-xs text-gray-500">
                        {formatPlayerTime(currentTime)} / {formatPlayerTime(duration)}
                    </span>
                </div>
                {data.lyrics.length !== 0 && <div className="space-y-4 mt-4">
                    {data.lyrics.map((lyric, index) => (
                        <div
                            key={lyric._id} 
                            className={`flex items- space-x-4 p-2 rounded-lg ${index % 2 === 0 ? 'bg-gray-100' : 'bg-gray-200'}`}
                        >
                            <div className='w-[90%]'>
                                <p className={`text-sm text-gray-800 font-medium`}>{lyric.text}</p>
                            </div>
                        </div>
                    ))}
                </div>}
            </div>
            <div className={`absolute right-[76px] top-2 cursor-pointer flex gap-1 border ${data?.lockSlok ? 'border-[#286de0]' : 'border-[#ff3f3f]'} rounded-md`}>
                <select 
                    disabled={loading} 
                    onChange={(e) => handleChange(data._id, e.target.value)} 
                    value={data?.lockSlok}
                    className={`bg-transparent  ${data?.lockSlok ? 'text-[#286de0]' : 'text-[#ff3f3f]'} text-base font-figtree font-normal focus:outline-none`}
                >
                    <option value={true} className='text-[#286de0]'>Locked</option>
                    <option value={false} className='text-[#ff3f3f]'>UnLocked</option>
                </select>
            </div>
            <div className='absolute right-9 top-1 cursor-pointer flex gap-1'>
                <button disabled={loading} onClick={() => handleEdit(data._id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                        <path fill={loading? "#86B0F4":"#286de0"} d="M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10s10-4.47 10-10S17.53 2 12 2m3.1 5.07c.14 0 .28.05.4.16l1.27 1.27c.23.22.23.57 0 .78l-1 1l-2.05-2.05l1-1c.1-.11.24-.16.38-.16m-1.97 1.74l2.06 2.06l-6.06 6.06H7.07v-2.06l6.06-6.06Z"/>
                    </svg>
                </button>
            </div>
            <div className='absolute right-1 top-1 cursor-pointer flex gap-1'>
                <button disabled={loading} onClick={() => handleDelete(data._id)}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 24 24">
                        <path fill={loading? "#FB9883":"#E23712"} d="M12 2c5.53 0 10 4.47 10 10s-4.47 10-10 10S2 17.53 2 12S6.47 2 12 2m5 5h-2.5l-1-1h-3l-1 1H7v2h10V7M9 18h6a1 1 0 0 0 1-1v-7H8v7a1 1 0 0 0 1 1Z"/>
                    </svg>
                </button>
            </div>
            {visible && <>
                <div className='w-full h-full fixed z-20 top-2.5 left-0 right-0 flex justify-center'>
                    <img className='w-60 h-60' src={data.slokImage} alt='' />
                </div>
                <div className='w-full h-full z-10 fixed top-0 left-0 right-0 bottom-0 rounded-xl bg-[#282c3f]/[0.5]' />
            </>}
        </div>
    );
};

const formatTime = (milliseconds) => {
  const minutes = Math.floor(milliseconds / 60000);
  const seconds = ((milliseconds % 60000) / 1000).toFixed(0);
  return `${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
};

const formatPlayerTime = (seconds) => {
    const minutes = Math.floor(seconds / 60);
    const remainingSeconds = Math.floor(seconds % 60);
    return `${minutes}:${remainingSeconds < 10 ? '0' : ''}${remainingSeconds}`;
  };

export default LibraryCard;